// The "this screen runs over Bluetooth" mark in a device screen's title bar —
// every device type (it lives in DeviceAppBar), 2026-10-18.
//
// Shown only while the device is pinned to Bluetooth (core/ble/bleForced) — the
// BLE Test screen's "Open full screen", or TouchScreen's Operate bar. Tap it to
// go back to the cloud. Leaving the screen does the same and drops the link, so
// a phone never stays silently pinned to BLE (the override is per session).

import React, { useEffect, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import BluetoothConnectedIcon from '@mui/icons-material/BluetoothConnected';
import { isForcedBle, onForcedBleChange, setForcedBle } from '../../../core/ble/bleForced';
import { closeControlLink } from '../../../core/ble/bleControl';

export default function BleLinkBadge({ uniqueNumber, color }) {
  const [, tick] = useState(0);
  useEffect(() => onForcedBleChange(() => tick((n) => n + 1)), []);
  useEffect(() => () => {
    if (isForcedBle(uniqueNumber)) {
      setForcedBle(uniqueNumber, false);
      closeControlLink();
    }
  }, [uniqueNumber]);

  if (!uniqueNumber || !isForcedBle(uniqueNumber)) return null;
  return (
    <Tooltip title="Working over Bluetooth — tap to go back to the cloud">
      <IconButton
        onClick={() => { setForcedBle(uniqueNumber, false); closeControlLink(); }}
        sx={{ color: color || '#64B5F6' }}
        aria-label="Over Bluetooth"
      >
        <BluetoothConnectedIcon />
      </IconButton>
    </Tooltip>
  );
}
